import { motion } from "framer-motion";

export default function Marquee() {
  const items = [
    "Stay. Sip. Socialize.",
    "✦",
    "Est. Mintogang, Gangtok",
    "✦",
    "16 rooms · 12 experiences",
    "✦",
    "Quiet after 9 PM",
    "✦",
    "Tibetan plates · Himalayan brews",
    "✦",
    "Bonfire nights",
    "✦",
    "The Nomikai Tribe",
    "✦",
  ];
  const line = items.join("   ");

  return (
    <section
      data-testid="marquee"
      className="relative overflow-hidden py-10 md:py-14 border-y border-white/5 bg-[#0a0a0a]"
    >
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 md:w-40 bg-gradient-to-r from-[#0a0a0a] to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 md:w-40 bg-gradient-to-l from-[#0a0a0a] to-transparent z-10" />

      <motion.div
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 60, repeat: Infinity, ease: "linear" }}
        className="flex whitespace-nowrap gap-10 font-display font-semibold text-5xl sm:text-6xl md:text-7xl tracking-tighter text-white/90"
      >
        <span>{line}</span>
        <span aria-hidden="true">{line}</span>
      </motion.div>
    </section>
  );
}
